import { useEffect, useState } from 'react';

export default function Hero() {
  const [animated, setAnimated] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [textCycle, setTextCycle] = useState(0);
  const [phoneScreen, setPhoneScreen] = useState(0);
  const [phoneFlipping, setPhoneFlipping] = useState(false);

  const backgroundImages = [
    "https://readdy.ai/api/search-image?query=Professional%20lawyer%20silhouette%20speaking%20on%20mobile%20phone%20in%20dark%20courthouse%20corridor%20with%20dramatic%20teal%20lighting%20and%20volumetric%20light%20rays%2C%20cinematic%20noir%20photography%2C%20high%20contrast%20moody%20atmosphere%2C%20architectural%20columns%20in%20background%2C%20professional%20legal%20environment%2C%20film%20grain%20texture%2C%20ultra%20wide%20angle%20perspective&width=1920&height=1080&seq=hero-bg-lawyer-phone-001&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Judge%20in%20black%20robes%20sitting%20at%20bench%20in%20dark%20courtroom%20with%20dramatic%20teal%20color%20grading%2C%20cinematic%20lighting%20with%20light%20shafts%20through%20windows%2C%20professional%20legal%20environment%2C%20moody%20atmospheric%20photography%2C%20high%20contrast%20noir%20style%2C%20architectural%20symmetry%2C%20deep%20shadows%20and%20teal%20highlights&width=1920&height=1080&seq=hero-bg-judge-002&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Legal%20documents%20and%20court%20papers%20on%20dark%20wooden%20desk%20with%20dramatic%20teal%20lighting%2C%20professional%20legal%20paperwork%20close-up%2C%20cinematic%20moody%20photography%2C%20high%20contrast%20noir%20style%2C%20shallow%20depth%20of%20field%2C%20atmospheric%20lighting%2C%20film%20grain%20texture%2C%20professional%20legal%20environment&width=1920&height=1080&seq=hero-bg-documents-003&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Attorney%20dictating%20into%20smartphone%20while%20walking%20in%20dark%20modern%20office%20corridor%2C%20professional%20lawyer%20using%20mobile%20phone%20for%20voice%20recording%2C%20cinematic%20teal%20color%20grading%2C%20moody%20atmospheric%20lighting%2C%20business%20professional%20silhouette%2C%20high%20contrast%20noir%20photography%2C%20motion%20blur%20effect&width=1920&height=1080&seq=hero-bg-dictate-004&orientation=landscape"
  ];

  const kineticPhrases = ['From Anywhere', 'Privilege Safe'];

  useEffect(() => {
    setAnimated(true);

    const imageInterval = setInterval(() => {
      setCurrentImageIndex((prev) => (prev + 1) % backgroundImages.length);
    }, 4000);

    const textInterval = setInterval(() => {
      setTextCycle((prev) => (prev + 1) % kineticPhrases.length);
    }, 2500);

    const phoneInterval = setInterval(() => {
      setPhoneFlipping(true);
      setTimeout(() => {
        setPhoneScreen((prev) => (prev + 1) % 2);
        setTimeout(() => {
          setPhoneFlipping(false);
        }, 50);
      }, 400);
    }, 5000);

    return () => {
      clearInterval(imageInterval);
      clearInterval(textInterval);
      clearInterval(phoneInterval);
    };
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Fading Background Slideshow */}
      <div className="absolute inset-0">
        {backgroundImages.map((img, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-[1500ms] ${
              currentImageIndex === index ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={img}
              alt="Background"
              className="w-full h-full object-cover object-center sm:object-center object-[70%_center]"
            />
          </div>
        ))}
        <div className="absolute inset-0 bg-gradient-to-r from-[#09090b]/60 via-[#09090b]/30 to-[#09090b]/10 max-sm:bg-gradient-to-b max-sm:from-[#09090b]/50 max-sm:via-[#09090b]/25 max-sm:to-[#09090b]/60"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-[#09090b]/60"></div>
      </div>

      <div className="relative z-10 w-full">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-24 sm:py-32">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            {/* Left Content */}
            <div className="space-y-6 sm:space-y-8">
              {/* Big Branding - Left Aligned, ENLARGED */}
              <div
                className={`flex items-center gap-0 -ml-3 sm:-ml-5 transition-all duration-700 ${
                  animated ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
                }`}
              >
                <img
                  src="https://static.readdy.ai/image/151e34d9a5807cd608014213251345d2/83f5e4b8fbdb9e6636dc2fdb7fe48e2c.png"
                  alt="HushLegal"
                  className="h-36 sm:h-52 lg:h-56 w-auto"
                />
                <h2 className="text-white text-[34px] sm:text-[52px] lg:text-[64px] font-black tracking-tighter hero-logo-glow -ml-2 sm:-ml-3">HushLegal</h2>
              </div>

              <div
                className={`inline-block border-2 border-[#06b6d4] bg-[#06b6d4]/10 px-5 py-2 rounded-full transition-all duration-700 ${
                  animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                }`}
                style={{ transitionDelay: '200ms' }}
              >
                <span className="text-[#06b6d4] text-[11px] sm:text-[12px] font-bold uppercase tracking-widest">
                  SECURE LEGAL AI
                </span>
              </div>

              {/* Main Headline */}
              <div className="space-y-3">
                <h1
                  className={`text-white font-black text-[32px] sm:text-[44px] lg:text-[52px] leading-[1.05] transition-all duration-700 ${
                    animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
                  }`}
                  style={{ transitionDelay: '300ms' }}
                >
                  AI-Drafted Pleadings and Contracts
                </h1>

                {/* Kinetic Text */}
                <div className="h-[50px] sm:h-[60px] lg:h-[70px] overflow-hidden relative">
                  {kineticPhrases.map((phrase, index) => (
                    <h1
                      key={phrase}
                      className={`text-[#06b6d4] font-black text-[32px] sm:text-[44px] lg:text-[52px] leading-[1.05] absolute transition-all duration-500 ${
                        textCycle === index
                          ? 'opacity-100 translate-y-0 scale-100'
                          : 'opacity-0 translate-y-8 scale-95'
                      }`}
                      style={{
                        textShadow: '0 0 60px rgba(6, 182, 212, 0.6), 0 0 120px rgba(6, 182, 212, 0.3)'
                      }}
                    >
                      {phrase}
                    </h1>
                  ))}
                </div>
              </div>

              <div
                className={`space-y-4 sm:space-y-5 max-w-[550px] transition-all duration-700 ${
                  animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                }`}
                style={{ transitionDelay: '500ms' }}
              >
                <p className="text-[#a1a1aa] text-[16px] sm:text-[18px] leading-relaxed">
                  Dictate from the courthouse hallway, your car, or your kitchen at midnight. Court-ready documents in seconds.
                </p>
                <p className="text-white text-[16px] sm:text-[18px] leading-relaxed font-medium">
                  Your sensitive data is protected, processed, and deleted. Never stored. Never exposed.
                </p>
              </div>

              <button
                onClick={() => scrollToSection('final-cta')}
                className={`group bg-[#d4af37] text-black text-[13px] sm:text-[17px] font-bold px-5 sm:px-10 py-3 sm:py-5 rounded-full shadow-xl hover:shadow-[0_0_40px_rgba(212,175,55,0.7)] hover:scale-105 transition-all duration-300 hero-cta-glow whitespace-normal sm:whitespace-nowrap cursor-pointer inline-flex items-center gap-2 sm:gap-3 text-center leading-tight ${
                  animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                }`}
                style={{ transitionDelay: '700ms' }}
              >
                <span>Join Founder Waitlist — Lock In Early Pricing</span>
                <i className="ri-arrow-right-line text-[18px] sm:text-[20px] group-hover:translate-x-2 transition-transform flex-shrink-0"></i>
              </button>

              <div
                className={`flex flex-wrap items-center gap-3 sm:gap-6 text-[#71717a] text-[12px] sm:text-[13px] transition-all duration-700 ${
                  animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
                }`}
                style={{ transitionDelay: '900ms' }}
              >
                <span className="text-[#06b6d4]">🔒</span>
                <span>Privilege Protected</span>
                <span className="text-[#3f3f46]">·</span>
                <span className="text-[#06b6d4]">📱</span>
                <span>Mobile-First</span>
                <span className="text-[#3f3f46]">·</span>
                <span className="text-[#06b6d4]">⚡</span>
                <span>Court-Ready in Seconds</span>
              </div>
            </div>

            {/* Right - iPhone 17 Pro Max Mockup */}
            <div
              className={`relative flex justify-center transition-all duration-1000 ${
                animated ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'
              }`}
              style={{ transitionDelay: '400ms' }}
            >
              <div className="relative hero-phone-float">
                {/* Phone Glow */}
                <div className="absolute -inset-10 bg-[#06b6d4]/15 rounded-[70px] blur-[60px] hero-phone-glow-pulse"></div>

                {/* iPhone 17 Pro Max Frame - Ultra thin bezels, titanium finish */}
                <div className="relative rounded-[44px] sm:rounded-[52px] shadow-[0_0_80px_rgba(6,182,212,0.15),0_25px_60px_rgba(0,0,0,0.6)] border border-[#4a4a4c]" style={{ background: 'linear-gradient(145deg, #2c2c2e 0%, #1c1c1e 50%, #2c2c2e 100%)' }}>
                  {/* Titanium side rails */}
                  <div className="absolute top-20 -right-[2px] w-[3px] h-14 bg-gradient-to-b from-[#5a5a5c] via-[#8a8a8c] to-[#5a5a5c] rounded-full"></div>
                  <div className="absolute top-20 -left-[2px] w-[3px] h-8 bg-gradient-to-b from-[#5a5a5c] via-[#8a8a8c] to-[#5a5a5c] rounded-full"></div>
                  <div className="absolute top-36 -left-[2px] w-[3px] h-14 bg-gradient-to-b from-[#5a5a5c] via-[#8a8a8c] to-[#5a5a5c] rounded-full"></div>
                  {/* Action button */}
                  <div className="absolute top-[72px] -left-[3px] w-[4px] h-8 bg-gradient-to-b from-[#6a6a6c] via-[#9a9a9c] to-[#6a6a6c] rounded-full"></div>

                  {/* Inner bezel - ultra thin */}
                  <div className="p-[3px] sm:p-[4px]">
                    {/* Screen */}
                    <div className="w-[260px] sm:w-[300px] h-[540px] sm:h-[620px] bg-[#000000] rounded-[42px] sm:rounded-[48px] overflow-hidden relative">

                      {/* Dynamic Island - pill shape */}
                      <div className="absolute top-3 left-1/2 -translate-x-1/2 z-30 flex items-center justify-center">
                        <div className="w-[90px] sm:w-[105px] h-[28px] sm:h-[32px] bg-black rounded-full flex items-center justify-center gap-2 shadow-[0_0_10px_rgba(0,0,0,0.8)]">
                          <div className="w-[10px] h-[10px] rounded-full bg-[#1a1a1c] border border-[#2a2a2c]"></div>
                        </div>
                      </div>

                      {/* Status Bar */}
                      <div className="absolute top-0 left-0 right-0 z-20 flex justify-between items-center px-6 sm:px-8 pt-[14px] sm:pt-[16px]">
                        <span className="text-white text-[12px] sm:text-[14px] font-semibold" style={{ fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif' }}>9:41</span>
                        <div className="flex items-center gap-[5px]">
                          <div className="flex items-end gap-[2px]">
                            <div className="w-[3px] h-[4px] bg-white rounded-[1px]"></div>
                            <div className="w-[3px] h-[6px] bg-white rounded-[1px]"></div>
                            <div className="w-[3px] h-[8px] bg-white rounded-[1px]"></div>
                            <div className="w-[3px] h-[10px] bg-white rounded-[1px]"></div>
                          </div>
                          <span className="text-white text-[11px] sm:text-[12px] font-medium ml-1">5G</span>
                          <div className="w-[22px] sm:w-[25px] h-[10px] sm:h-[11px] border border-white/80 rounded-[3px] relative ml-1">
                            <div className="absolute inset-[1.5px] right-[3px] bg-[#30d158] rounded-[1.5px]"></div>
                            <div className="absolute right-[-3px] top-1/2 -translate-y-1/2 w-[1.5px] h-[4px] bg-white/80 rounded-r-full"></div>
                          </div>
                        </div>
                      </div>

                      {/* Screen 1: Voice Recording */}
                      <div
                        className={`absolute inset-0 pt-[52px] sm:pt-[56px] transition-all duration-500 ${
                          phoneFlipping
                            ? 'opacity-0 scale-90'
                            : phoneScreen === 0
                              ? 'opacity-100 scale-100'
                              : 'opacity-0 scale-90'
                        }`}
                      >
                        <div className="px-4 sm:px-5 space-y-3 sm:space-y-4 pt-3 sm:pt-4">
                          <div className="flex items-center gap-2 sm:gap-3">
                            <img
                              src="https://static.readdy.ai/image/151e34d9a5807cd608014213251345d2/83f5e4b8fbdb9e6636dc2fdb7fe48e2c.png"
                              alt="HushLegal"
                              className="h-6 sm:h-7 w-auto"
                            />
                            <span className="text-white text-[14px] sm:text-[15px] font-bold">HushLegal</span>
                          </div>

                          {/* Document type pill */}
                          <div className="flex gap-2">
                            <div className="bg-[#06b6d4]/20 border border-[#06b6d4]/40 text-[#06b6d4] text-[10px] sm:text-[11px] font-medium px-3 py-1.5 rounded-full">Motion</div>
                            <div className="bg-[#1c1c1e] border border-[#3a3a3c] text-[#8e8e93] text-[10px] sm:text-[11px] px-3 py-1.5 rounded-full">Brief</div>
                            <div className="bg-[#1c1c1e] border border-[#3a3a3c] text-[#8e8e93] text-[10px] sm:text-[11px] px-3 py-1.5 rounded-full">Contract</div>
                          </div>

                          {/* Voice Waveform */}
                          <div className="bg-[#1c1c1e] rounded-2xl p-4 sm:p-5 border border-[#2c2c2e]">
                            <div className="flex items-center justify-center gap-[3px] h-14 sm:h-16">
                              {[...Array(24)].map((_, i) => (
                                <div
                                  key={i}
                                  className="w-[2px] sm:w-[2.5px] bg-gradient-to-t from-[#06b6d4] to-[#06b6d4]/60 rounded-full hero-waveform-bar"
                                  style={{
                                    animationDelay: `${i * 0.04}s`,
                                    height: `${Math.random() * 35 + 8}px`
                                  }}
                                ></div>
                              ))}
                            </div>
                            <div className="flex items-center justify-between mt-3">
                              <p className="text-[#06b6d4] text-[10px] sm:text-[11px] font-medium">Recording...</p>
                              <p className="text-[#8e8e93] text-[10px] sm:text-[11px]">0:47</p>
                            </div>
                          </div>

                          {/* Typing Text */}
                          <div className="bg-[#1c1c1e] rounded-2xl p-3 sm:p-4 border border-[#2c2c2e]">
                            <p className="text-[#8e8e93] text-[9px] sm:text-[10px] mb-1.5">Live Transcription</p>
                            <p className="text-white text-[11px] sm:text-[12px] leading-relaxed hero-typing-text overflow-hidden whitespace-nowrap border-r-2 border-[#06b6d4]">
                              Opposition to summary judgment...
                            </p>
                          </div>

                          {/* Generate Button */}
                          <button className="w-full bg-[#06b6d4] text-black font-bold py-3 sm:py-3.5 rounded-2xl text-[13px] sm:text-[14px] flex items-center justify-center gap-2">
                            <i className="ri-sparkling-line text-[16px]"></i>
                            Generate Document
                          </button>

                          {/* Bottom indicator */}
                          <div className="flex justify-center pt-1">
                            <div className="w-28 sm:w-32 h-1 bg-white/20 rounded-full"></div>
                          </div>
                        </div>
                      </div>

                      {/* Screen 2: Legal Pleading Document */}
                      <div
                        className={`absolute inset-0 pt-[52px] sm:pt-[56px] transition-all duration-500 ${
                          phoneFlipping
                            ? 'opacity-0 scale-90'
                            : phoneScreen === 1
                              ? 'opacity-100 scale-100'
                              : 'opacity-0 scale-90'
                        }`}
                      >
                        <div className="px-3 sm:px-4 pt-3 sm:pt-4">
                          {/* Document Preview */}
                          <div className="bg-white rounded-2xl p-3 sm:p-4 shadow-lg overflow-hidden" style={{ height: 'calc(100% - 70px)', maxHeight: '420px' }}>
                            {/* Pleading Header */}
                            <div className="text-center border-b border-gray-200 pb-2 sm:pb-3 mb-2 sm:mb-3">
                              <p className="text-black text-[7px] sm:text-[8px] font-bold uppercase tracking-wide">United States District Court</p>
                              <p className="text-black text-[6px] sm:text-[7px] uppercase text-gray-600">Eastern District of Michigan</p>
                            </div>

                            {/* Case Caption */}
                            <div className="border border-gray-300 p-2 mb-2 sm:mb-3 text-[6px] sm:text-[7px] rounded-lg">
                              <div className="flex justify-between">
                                <div className="flex-1">
                                  <p className="text-black font-semibold">SMITH INDUSTRIES, LLC,</p>
                                  <p className="text-gray-600 ml-3">Plaintiff,</p>
                                  <p className="text-black mt-0.5">v.</p>
                                  <p className="text-black font-semibold mt-0.5">JONES CORPORATION,</p>
                                  <p className="text-gray-600 ml-3">Defendant.</p>
                                </div>
                                <div className="text-right text-gray-500">
                                  <p>Case No. 2:24-cv-01234</p>
                                  <p className="mt-0.5">Hon. Sarah Williams</p>
                                </div>
                              </div>
                            </div>

                            {/* Document Title */}
                            <p className="text-black text-[8px] sm:text-[9px] font-bold text-center mb-2 sm:mb-3 uppercase leading-tight">
                              Plaintiff&apos;s Opposition to<br />Defendant&apos;s Motion for Summary Judgment
                            </p>

                            {/* Document Body */}
                            <div className="space-y-1.5 text-[5.5px] sm:text-[6px] text-gray-800 leading-relaxed">
                              <p className="font-bold text-black">I. INTRODUCTION</p>
                              <p className="text-justify indent-3">
                                Plaintiff Smith Industries, LLC respectfully submits this Opposition to Defendant&apos;s Motion for Summary Judgment. Genuine issues of material fact preclude summary judgment.
                              </p>
                              <p className="font-bold text-black mt-1.5">II. STATEMENT OF FACTS</p>
                              <p className="text-justify indent-3">
                                On March 15, 2023, the parties entered into a binding agreement whereby Defendant agreed to deliver...
                              </p>
                              <p className="font-bold text-black mt-1.5">III. LEGAL STANDARD</p>
                              <p className="text-justify indent-3">
                                Summary judgment is appropriate only where there is no genuine dispute as to any material fact. Fed. R. Civ. P. 56(a)...
                              </p>
                            </div>
                          </div>

                          {/* Download Button */}
                          <button className="w-full bg-[#06b6d4] text-black font-bold py-2.5 sm:py-3 rounded-2xl text-[12px] sm:text-[13px] mt-2 sm:mt-3 flex items-center justify-center gap-2">
                            <i className="ri-download-line"></i>
                            Download .docx
                          </button>

                          {/* Bottom indicator */}
                          <div className="flex justify-center pt-2">
                            <div className="w-28 sm:w-32 h-1 bg-white/20 rounded-full"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes heroFloat {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-18px) rotate(0.5deg); }
        }
        .hero-phone-float {
          animation: heroFloat 6s ease-in-out infinite;
        }
        @keyframes heroPhoneGlow {
          0%, 100% { opacity: 0.3; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(1.04); }
        }
        .hero-phone-glow-pulse {
          animation: heroPhoneGlow 4s ease-in-out infinite;
        }
        @keyframes heroWaveform {
          0%, 100% { transform: scaleY(0.3); }
          50% { transform: scaleY(1); }
        }
        .hero-waveform-bar {
          animation: heroWaveform 0.8s ease-in-out infinite;
        }
        @keyframes heroTyping {
          from { width: 0; }
          to { width: 100%; }
        }
        .hero-typing-text {
          animation: heroTyping 3s steps(30) infinite;
        }
        @keyframes heroCtaGlow {
          0%, 100% { box-shadow: 0 0 20px rgba(212, 175, 55, 0.4); }
          50% { box-shadow: 0 0 50px rgba(212, 175, 55, 0.8); }
        }
        .hero-cta-glow {
          animation: heroCtaGlow 2s ease-in-out infinite;
        }
        @keyframes heroLogoGlow {
          0%, 100% { filter: drop-shadow(0 0 10px rgba(6, 182, 212, 0.3)); }
          50% { filter: drop-shadow(0 0 30px rgba(6, 182, 212, 0.6)); }
        }
        .hero-logo-glow {
          animation: heroLogoGlow 3s ease-in-out infinite;
        }
      `}</style>
    </section>
  );
}
